import React from "react";
import CompanyImage from "../common/company_image";
import CompanyName from "../common/company_name";
import DeleteInvestment from "./delete_investment";

function Investment(props) {
  return (
    <div className='col-4 col-sm-3 col-lg-2 text-center mb-3 invest-unit'>
      <span className='company-logo d-flex align-content-center'>
        <CompanyImage {...props} />
      </span>
      <CompanyName {...props} />
      <DeleteInvestment {...props} />
    </div>
  );
}

export default Investment;
